import { Divider, Layout, Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { useMatch, useResolvedPath } from 'react-router-dom';
import DateInformationFooter from '../../../shared/date-information-footer';
import { ArchivedCaseListCommonContainer } from '../../../shared/related-cases/archived-case-list-common.container';
import { ActiveCaseListCommonContainer } from './active-case-list-common.container';

const { Sider } = Layout;

const TabKeys = {
  Active: 'active',
  Archived: 'archived'
};

interface ApplicantRequestProps {
  applicantId: string;
  refetch?: boolean | undefined;
}
export const ApplicantRequest: React.FC<ApplicantRequestProps> = (props) => {
  const [activeTabKey, setActiveTabKey] = useState<string>();
  const currentRoutePath = useResolvedPath('').pathname;
  const activeRouteMatch = useMatch(currentRoutePath + '/cases/:caseId/case-type/:type/active/*');
  const archivedRouteMatch = useMatch(currentRoutePath + '/cases/:caseId/case-type/:type/archived/*');

  useEffect(() => {
    if (activeRouteMatch) {
      setActiveTabKey(TabKeys.Active);
    } else if (archivedRouteMatch) {
      setActiveTabKey(TabKeys.Archived);
    }
  }, [activeRouteMatch, archivedRouteMatch]);

  const items = [
    {
      key: TabKeys.Active,
      label: 'Active',
      children: <ActiveCaseListCommonContainer refetch={props?.refetch ?? false} isVerticalColumn={true} applicantId={props.applicantId} />
    },
    {
      key: TabKeys.Archived,
      label: 'Archived',
      children: <ArchivedCaseListCommonContainer isVerticalColumn={true} applicantId={props.applicantId} />
    }
  ];

  const handleOnTabChange = (key: string) => {
    setActiveTabKey(key);
  };
  return (
    <Layout style={{ minHeight: '100%', borderBottom: '1px solid #e6e6e6' }} hasSider>
      <Sider
        width={300}
        style={{
          borderRight: '1px solid #e6e6e6',
          textAlign: 'center',
          background: 'transparent'
        }}
        theme="light"
      >
        <Tabs items={items} centered activeKey={activeTabKey} onChange={handleOnTabChange} />
        <Divider style={{ margin: '15px 0 10px 0' }} />
        <DateInformationFooter />
      </Sider>
    </Layout>
  );
};
